export default __webpack_public_path__ + "static/src/companys/ttl/assets/images/icons/market_comment_add_light.png";